{
  "overview": {
    "title": "Infrastructure Command",
    "description": "Orchestrating sovereign compute, distributed data clusters, and national connectivity backbone. institutional-grade mesh governance.",
    "system": "CORE_INFRA",
    "badge": "BACKBONE ACTIVE",
    "deep_scan": "Deep Scan Active",
    "initiate_audit": "Initiate Audit",
    "system_health": "System Health",
    "uptime": "Uptime",
    "compute_load": "Compute Load",
    "threat_level": "Threat Level",
    "database_clusters": "Distributed Data Grid",
    "database_clusters_desc": "Institutional-grade data synchronization engine for sovereign legal and financial clusters.",
    "sync_status": "Sync Status",
    "global_iops": "Global IOPS",
    "cluster_count": "Cluster Count",
    "nominal": "NOMINAL",
    "cyber_command": "Cyber Command",
    "cyber_command_desc": "Real-time multi-layered defense system with automated threat mitigation.",
    "encryption": "Encryption",
    "active_guards": "Active Guards",
    "mesh_connectivity": "Mesh Connectivity",
    "mesh_connectivity_desc": "High-performance backbone routing across the sovereign network.",
    "global_latency": "Global Latency",
    "throughput": "Throughput",
    "edge_nodes": "Edge Nodes",
    "identity_matrix": "Identity Matrix (CRM)",
    "identity_matrix_desc": "Deep relationship management engine with institutional access control.",
    "registry_size": "Registry Size",
    "kyc_verified": "KYC Verified",
    "auth_success": "Auth Success",
    "continuity_engine": "Continuity Engine",
    "continuity_engine_desc": "Geo-redundant backup system with sub-millisecond replication.",
    "dr_readiness": "DR Readiness",
    "sync_drift": "Sync Drift",
    "cold_storage": "Cold Storage",
    "certified": "CERTIFIED",
    "active": "ACTIVE",
    "core_telemetry": "Core Telemetry",
    "hardware_pulse": "Hardware Pulse",
    "configure_grid": "Configure Grid",
    "aggregate_performance": "Aggregate Performance",
    "realtime_balancing": "Real-time Load Balancing",
    "window_24h": "24h Window",
    "live_monitoring": "Live Monitoring",
    "timeline_24h": "T-24H Timeline",
    "incident_command_log": "Incident Command Log",
    "forensic_telemetry": "Forensic Telemetry",
    "archives": "Archives",
    "secure_session": "Secure Session • Charikaty Sovereign",
    "warning": "Warning",
    "neural_compute_load": "Neural Compute Load",
    "matrix_memory": "Matrix Memory",
    "io_flux": "I/O Flux",
    "command_view": "Command View",
    "status_nominal": "Nominal",
    "status_warning": "Warning"
  },
  "security": {
    "title": "Sovereign Security",
    "description": "Ministerial-grade perimeter surveillance and real-time forensic auditing.",
    "system": "SECURITY_OPS",
    "audit_flow": "Audit Flow",
    "stress_test": "Stress Test",
    "threat_surface": "Threat Surface",
    "aggregated_risk_exposure": "Aggregated Risk Exposure",
    "cryptographic_load": "Cryptographic Load",
    "hsm_cluster_capacity": "HSM Cluster Capacity",
    "vault_sync_status": "Vault Sync Status",
    "multi_zone_consistency": "Multi-Zone Consistency",
    "identity_trust": "Identity Trust",
    "biometric_zero_trust": "Biometric Zero-Trust",
    "tabs": {
      "overview": "OVERVIEW",
      "encryption": "ENCRYPTION",
      "access": "ACCESS",
      "logs": "LOGS"
    },
    "realtime_forensic_feed": "Real-time Forensic Feed",
    "institutional_audit": "Institutional Audit",
    "live_transaction_stream": "Live Transaction Stream",
    "system_live": "SYSTEM_LIVE",
    "nodes_checked": "Nodes Checked: 100%",
    "trust_index": "Trust Index",
    "perimeter_grid": "Perimeter Grid",
    "ministerial_surveillance": "Ministerial Surveillance",
    "global_anomaly_vector": "Global Anomaly Vector",
    "breach_identified": "BREACH_IDENTIFIED",
    "nominal_stable": "NOMINAL_STABLE",
    "lock_high_gates": "Lock High-Gates",
    "cycle_perimeter": "Cycle Perimeter",
    "institutional_forensic_log": "Institutional Forensic Log",
    "ministerial_access_system_traces": "Ministerial Access & System Traces",
    "master_archives": "Master Archives",
    "view_trace": "View Trace",
    "entropy_optimization": "Entropy Optimization",
    "multi_source_randomness_generation": "Multi-Source Randomness Generation",
    "master_key_rotation_verified": "Master Key Rotation Verified",
    "sources": {
      "a": "Source A (HSM)",
      "b": "Source B (Quantum)",
      "c": "Source C (Backbone)",
      "aggregated": "Aggregated Pool"
    },
    "bits_h": "Bits/H",
    "module_archive": "MODULE ARCHIVE",
    "scanning_sovereign_data_silos": "Scanning sovereign data silos for historical traces...",
    "access_control": "Access Control",
    "sovereign_authority_matrix": "Sovereign Authority Matrix",
    "manage_authority": "Manage Authority",
    "policy_compliance": "Policy Compliance",
    "gain": "Gain",
    "access_items": {
      "ministerial_access": "Ministerial Access",
      "cfo_master_key": "CFO Master Key",
      "compliance_audit": "Compliance Audit",
      "third_party_hubs": "Third-Party Hubs",
      "status_active": "Active",
      "status_engaged": "Engaged",
      "status_nominal": "Nominal",
      "status_restricted": "Restricted"
    },
    "vault_v4": "Vault_v4",
    "secure_sync": "SECURE_SYNC",
    "aes_gcm": "AES-GCM-256",
    "key_count": "Key Count",
    "integrity": "Integrity",
    "hsm_module_locked": "HSM-Module-Locked",
    "sovereign_vault": "Sovereign Vault: {{id}}",
    "hsm_id": "HSM_ID: {{id}}_ALPHA",
    "integrity_verification": "Integrity Verification:",
    "enforced_active": "ENFORCED_ACTIVE",
    "active_keys": "Active Keys",
    "rotation_cycle": "Rotation Cycle",
    "entropy_score": "Entropy Score",
    "access_load": "Access Load",
    "days_14": "14 Days",
    "key_matrix_archive": "Key Matrix Archive",
    "export_report": "Export Report",
    "class": "Class: {{type}}",
    "created": "Created: {{date}}",
    "active": "Active",
    "rotate_master_keys": "Rotate Master Keys",
    "run_forensic_audit": "Run Forensic Audit",
    "sovereign_integrity_sealed": "Sovereign Integrity Sealed",
    "charikaty_security_layer": "Charikaty Security Layer",
    "system_user": "SYSTEM",
    "categories": {
      "ACCESS": "Access",
      "TRANSACTION": "Transaction",
      "ENCRYPTION": "Encryption",
      "THREAT": "Threat",
      "SYSTEM": "System"
    },
    "tx_types": {
      "OUTBOUND": "Outbound",
      "SWIFT": "SWIFT",
      "INTERNAL": "Internal"
    },
    "severities": {
      "low": "Low",
      "medium": "Medium",
      "high": "High",
      "critical": "Critical"
    },
    "tx_statuses": {
      "approved": "Approved",
      "flagged": "Flagged",
      "blocked": "Blocked"
    }
  },
  "databases": {
    "title": "Distributed Data Grid",
    "description": "Institutional-grade data synchronization engine for sovereign legal and financial clusters. Enforced atomic consistency.",
    "system": "CORE_DATA_BACKBONE",
    "badge": "Institutional Grid Active",
    "global_sync": "Global Sync",
    "syncing": "Syncing...",
    "audit_lineage": "Audit Lineage",
    "metrics": {
      "distributed_traces": "Distributed Traces",
      "aggregated_records": "Aggregated Sovereign Records",
      "network_throughput": "Network Throughput",
      "replication_stream": "Real-time Replication Stream",
      "hash_verification": "Hash Verification",
      "no_anomalies": "No Anomalies Identified",
      "crypto_layer": "Crypto Layer",
      "module_encryption": "Module-Level Encryption"
    },
    "clusters": {
      "legal": "Legal Repository",
      "financial": "Financial Ledger",
      "operational": "Sovereign Core",
      "offline": "Offline",
      "active": "Module Active",
      "standby": "Standby",
      "metrics_unavailable": "Metrics Unavailable",
      "record_volume": "Record Volume",
      "integrity_level": "Integrity Level",
      "alpha_7": "Sovereign Cluster Alpha-7"
    },
    "topology": {
      "title": "Sovereign Mesh Topology",
      "consensus": "Regional Consensus: Active (Paxos-v4)",
      "latency": "Cluster Latency",
      "global_sync_locked": "Global Sync Locked"
    },
    "explorer": {
      "placeholder": "SCANNING {{db}} MASTER INDEX...",
      "class_all": "Class: All Vectors",
      "no_records": "No matching records identified",
      "grid_empty": "Sovereign Data Grid is Empty for this selection",
      "table": {
        "ref": "Master Record Ref",
        "entity": "Sovereign Entity / Asset",
        "class": "Security Class",
        "integrity": "Integrity Vector",
        "value": "Value Mapping"
      }
    },
    "drawer": {
      "master_id": "Master ID: {{id}}",
      "system_hash": "System Hash:",
      "lifecycle": "Lifecycle Stage",
      "asset_magnitude": "Asset Magnitude",
      "classification": "Classification Level",
      "security_manifest": "Security Manifest",
      "manifest_desc": "Sovereign Data Classification",
      "vector_class": "Vector Classification",
      "access_protocol": "Access Protocol",
      "metadata_matrix": "Master Metadata Matrix",
      "edit_params": "Edit Parameters",
      "audit_view": "Full Audit View",
      "version_lineage": "Version Lineage",
      "secure_handshake": "Secure Handshake",
      "integrity_seal": "Integrity Seal Active",
      "aes_layer": "AES-256 Multi-Layer",
      "backbone": "Sovereign Data Backbone",
      "market_normalized": "Market Normalized",
      "sensitivity_level": "Sensitivity Level"
    },
    "flow": {
      "step": "Step {{num}}",
      "replicating": "Replicating..."
    },
    "node_modal": {
      "title": "Cluster Node: {{id}}",
      "mesh_active": "{{region}} Mesh Active",
      "metrics": {
        "cpu": "Processor Load",
        "io": "Network I/O",
        "storage": "Storage Used",
        "health": "Health Index"
      },
      "thread_analytics": "Active Thread Analytics",
      "nominal_flow": "Nominal Flow",
      "degraded": "Degraded Performance",
      "reboot": "Reboot Secure Cluster",
      "audit_storage": "Audit Storage"
    },
    "audit_modal": {
      "title": "Data Lineage Audit",
      "traceability": "Full Traceability Enabled",
      "export": "Export Audit (PDF)"
    },
    "terminal": {
      "title": "SOVEREIGN_DEBUG_SHELL",
      "init": "Initializing connection to global backbone...",
      "auth": "Authentication: SUCCESS (Sovereign Root)",
      "status_logs": "--- SYSTEM STATUS LOGS ---"
    }
  },
  "connectivity": {
    "title": "Neural Backbone",
    "description": "Sovereign grid surveillance, high-density uplink optimization, and cross-region topology orchestration.",
    "system": "BACKBONE_OPS",
    "actions": {
      "optimize": "Optimize Topology"
    },
    "metrics": {
      "latency": "Latency Vector",
      "latency_sla": "Ministerial SLA Target: < 15ms",
      "uplink": "Uplink Density",
      "uplink_desc": "Concurrent Peer handshakes",
      "coverage": "Grid Coverage",
      "coverage_desc": "Geo-Isolated Clusters",
      "uptime": "Backbone Uptime",
      "uptime_desc": "Core System Vitality"
    },
    "tabs": {
      "nodes": "Edge Infrastructure",
      "endpoints": "API Endpoints"
    },
    "search": "Search infrastructure matrix...",
    "table": {
      "node_id": "Node Identifier",
      "region": "Geo Region",
      "health": "Health Vector",
      "telemetry": "Telemetry",
      "perimeter": "Perimeter",
      "grid_load": "Grid Load",
      "endpoint_path": "Endpoint Path",
      "method": "Method",
      "audit_status": "Audit Status",
      "performance": "P99 Performance",
      "total_calls": "{{count}} TOTAL_CALLS / HOUR",
      "error_rate": "Error Rate:",
      "nodes": "Nodes"
    },
    "topology": {
      "title": "Dynamic Grid Topology",
      "subtitle": "Sovereign-Grade Packet Orchestration Engine",
      "validated": "Validated",
      "in_flight": "In-Flight",
      "anycast": "Anycast",
      "global_wan": "Global WAN",
      "sovereign_gateway": "Sovereign Gateway",
      "internal_clusters": "Internal Data Clusters",
      "packet_audit": "Deep Packet Audit",
      "stealth_flow": "Verified Stealth Flow",
      "stealth_desc": "Advanced mTLS & HSM handshakes on every ingress point.",
      "mapping": "Topology Mapping",
      "ai_grid": "AI Optimized Grid",
      "ai_grid_desc": "Dynamic reconfiguration of routes based on neural load patterns.",
      "resilience": "Anycast Resilience",
      "failover": "Multi-Layer Failover",
      "failover_desc": "Zero-downtime geo-switching with active-active dispersion."
    },
    "vitality": {
      "title": "Grid Vitality",
      "subtitle": "Sovereign Resilience Matrix",
      "bgp": "BGP Convergence",
      "anycast_nodes": "Anycast Nodes",
      "corruption": "Packet Corruption",
      "decay": "Fiber Decay Index",
      "aggregate_load": "Aggregate Grid Load",
      "sync": "Cross-Region Sync",
      "synchronized": "SYNCHRONIZED",
      "analysis": "Topology Analysis",
      "nominal_grid": "NOMINAL_GRID",
      "active_count": "{{count}}_ACTIVE",
      "corruption_lim": "0.0001%_LIM",
      "decay_rate": "0.004%/YR",
      "util_suffix": "_UTIL"
    },
    "feed": {
      "title": "Institutional Feed",
      "subtitle": "Live Backbone Forensic Stream",
      "streaming": "STREAMING",
      "source_node": "SOURCE_NODE:",
      "audit_verified": "Neural Grid Audit Verified v4.2"
    },
    "node_modal": {
      "protocol": "Node Protocol:",
      "backbone_zone": "BACKBONE_ZONE",
      "latency": "Edge Latency",
      "load_index": "Grid Load Index",
      "health": "Network Health",
      "telemetry_title": "Sovereign Resource Telemetry",
      "bandwidth": "Backbone Bandwidth",
      "memory": "Node Cluster Memory",
      "transport": "Secure Transport Protocols",
      "decommission": "Decommission Node",
      "initialize": "Initialize Node",
      "parametrics": "Node Parametrics",
      "network_layer": "Sovereign Network Layer",
      "protocols": {
        "tls": "TLS 1.3 (Sovereign)",
        "http3": "HTTP/3 over QUIC",
        "waf": "Institutional WAF-L7",
        "anycast": "Anycast Mesh IP (Masked)",
        "mtls": "mTLS Mutual Auth"
      },
      "identity_verified": "mTLS_VERIFIED_IDENTITY",
      "isolation_active": "GEOGRAPHIC_ISOLATION_ACTIVE"
    },
    "status": {
      "healthy": "Healthy",
      "online": "Online",
      "offline": "Offline",
      "warning": "Warning",
      "critical": "Critical"
    }
  }
}